'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys2 = require('ramda/src/keys');

var _keys3 = _interopRequireDefault(_keys2);

var _find2 = require('ramda/src/find');

var _find3 = _interopRequireDefault(_find2);

var _reduce2 = require('ramda/src/reduce');

var _reduce3 = _interopRequireDefault(_reduce2);

var _path2 = require('ramda/src/path');

var _path3 = _interopRequireDefault(_path2);

var _is2 = require('ramda/src/is');

var _is3 = _interopRequireDefault(_is2);

var _toPairs2 = require('ramda/src/toPairs');

var _toPairs3 = _interopRequireDefault(_toPairs2);

var _unnest2 = require('ramda/src/unnest');

var _unnest3 = _interopRequireDefault(_unnest2);

var _values2 = require('ramda/src/values');

var _values3 = _interopRequireDefault(_values2);

var _assocPath2 = require('ramda/src/assocPath');

var _assocPath3 = _interopRequireDefault(_assocPath2);

var _findIndex2 = require('ramda/src/findIndex');

var _findIndex3 = _interopRequireDefault(_findIndex2);

var _propEq2 = require('ramda/src/propEq');

var _propEq3 = _interopRequireDefault(_propEq2);

var _any2 = require('ramda/src/any');

var _any3 = _interopRequireDefault(_any2);

var _contains2 = require('ramda/src/contains');

var _contains3 = _interopRequireDefault(_contains2);

var _equals2 = require('ramda/src/equals');

var _equals3 = _interopRequireDefault(_equals2);

var _pathOr2 = require('ramda/src/pathOr');

var _pathOr3 = _interopRequireDefault(_pathOr2);

var _reverse2 = require('ramda/src/reverse');

var _reverse3 = _interopRequireDefault(_reverse2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactFinalForm = require('react-final-form');

var _finalFormArrays = require('final-form-arrays');

var _finalFormArrays2 = _interopRequireDefault(_finalFormArrays);

var _experiumPlayerHelpers = require('experium-player-helpers');

var _Page = require('./Page');

var _Page2 = _interopRequireDefault(_Page);

var _platform = require('./platform');

var _value = require('../utils/value');

var _getButtons = require('../utils/getButtons');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var formMutators = _extends({}, _finalFormArrays2.default, {
    revert: function revert(_ref, state, tools) {
        var _ref2 = _slicedToArray(_ref, 1),
            name = _ref2[0];

        tools.changeValue(state, name, function (array) {
            return (0, _reverse3.default)(array || []);
        });
    },
    new: function _new(_ref3, state, tools) {
        var _ref4 = _slicedToArray(_ref3, 3),
            name = _ref4[0],
            index = _ref4[1],
            value = _ref4[2];

        tools.changeValue(state, name, function (array) {
            var copy = [].concat(_toConsumableArray(array || []));
            copy.splice(index, 0, value);
            return copy;
        });
    }
});

var Player = function (_Component) {
    _inherits(Player, _Component);

    function Player(props) {
        _classCallCheck(this, Player);

        var _this = _possibleConstructorReturn(this, (Player.__proto__ || Object.getPrototypeOf(Player)).call(this, props));

        _initialiseProps.call(_this);

        var progress = (0, _pathOr3.default)(0, ['answers', 'percent'], props.data);
        var pagesLength = (0, _pathOr3.default)([], ['view', 'pages'], props.data).length;
        var currentPage = Math.round(progress * pagesLength / 100);

        _this.state = {
            page: 1,
            values: _this.getInitialValues(),
            error: false
        };
        return _this;
    }

    _createClass(Player, [{
        key: 'componentDidCatch',
        value: function componentDidCatch(error) {
            this.setState({
                error: error
            });

            setTimeout(function () {
                throw error;
            });
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(next) {
            var items = (0, _pathOr3.default)([], ['answers', 'results', 'items'], this.props.data);
            var nextItems = (0, _pathOr3.default)([], ['answers', 'results', 'items'], next.data);

            if (!(0, _equals3.default)(items, nextItems)) {
                this.setState({ values: this.getInitialValues(next.data) });
            }
        }
    }, {
        key: 'getDictionaries',
        value: function getDictionaries() {
            return this.props.data.scales || [];
        }
    }, {
        key: 'getInitialValues',
        value: function getInitialValues() {
            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.data;

            var items = (0, _pathOr3.default)([], ['answers', 'results', 'items'], data);

            var resultValues = items.length ? items.map(function (item) {
                return [item.id, {
                    value: (0, _value.decodeValue)(item.type, item.value, item) || null,
                    type: item.type
                }];
            }) : [];

            var withTable = {};

            (resultValues || []).forEach(function (_ref5, valIndex) {
                var _ref6 = _slicedToArray(_ref5, 2),
                    key = _ref6[0],
                    value = _ref6[1];

                if ((0, _contains3.default)('#', key)) {
                    var findItem = function findItem(name) {
                        return function (item) {
                            return item.type === 'table' && (0, _any3.default)(function (item) {
                                return item.type === 'table' ? (0, _any3.default)((0, _propEq3.default)('id', name), item.items) : (0, _propEq3.default)('id', name, item);
                            }, item.items);
                        };
                    };

                    var _key$split = key.split('#'),
                        _key$split2 = _slicedToArray(_key$split, 2),
                        name = _key$split2[0],
                        index = _key$split2[1];

                    var page = (0, _findIndex3.default)(function (item) {
                        return (0, _any3.default)(findItem(name), item.items);
                    }, (0, _pathOr3.default)([], ['view', 'pages'], data));
                    var elemNum = (0, _findIndex3.default)(findItem(name), ((0, _pathOr3.default)([], ['view', 'pages'], data)[page] || []).items || []);

                    value['#index'] = '#' + index;
                    value['#valIndex'] = valIndex;
                    withTable = elemNum >= 0 ? (0, _assocPath3.default)(['table-' + page + '-' + elemNum, +index - 1, name], value, withTable) : withTable;
                } else {
                    withTable[key] = value;
                }
            });

            (0, _pathOr3.default)([], ['view', 'pages'], data).forEach(function (page, pageIndex) {
                (page.items || []).forEach(function (item, itemIndex) {
                    if (item.type === 'table') {
                        var sortValues = withTable['table-' + pageIndex + '-' + itemIndex];
                        if (sortValues) {
                            withTable['table-' + pageIndex + '-' + itemIndex] = sortValues.filter(Boolean).sort(function (a, b) {
                                return (0, _pathOr3.default)(0, [0, '#valIndex'], (0, _values3.default)(a)) - (0, _pathOr3.default)(0, [0, '#valIndex'], (0, _values3.default)(b));
                            });
                        } else {
                            withTable['table-' + pageIndex + '-' + itemIndex] = [{}];
                        }
                    }
                });
            });

            return withTable;
        }
    }, {
        key: 'isLastPage',
        value: function isLastPage() {
            var pages = (0, _pathOr3.default)([], ['view', 'pages'], this.props.data);
            var pagesCount = 1;
            var pagesLength = pages.length;

            return this.state.page >= pagesCount - 1;
        }
    }, {
        key: 'getResult',
        value: function getResult(resultValues, aborted, nextPage) {
            var _this2 = this;

            var results = _extends({}, (0, _assocPath3.default)(['results', 'aborted'], aborted, this.props.data.answers), {
                percent: aborted ? this.getProgress(nextPage) : 100
            });

            return (0, _assocPath3.default)(['results', 'items'], (0, _unnest3.default)((0, _toPairs3.default)(resultValues).map(function (_ref7) {
                var _ref8 = _slicedToArray(_ref7, 2),
                    id = _ref8[0],
                    v = _ref8[1];

                var isTable = (0, _is3.default)(Array, v);
                var isReverseTable = isTable ? resultValues[id + '-revert'] : false;
                var initialValues = (0, _path3.default)([id], _this2.state.values) || [];
                var initialLength = isTable ? (0, _reduce3.default)(function (max, value) {
                    var num = (0, _path3.default)([0, '#index'], (0, _values3.default)(value));

                    if (num) {
                        var index = Number(num.replace('#', ''));
                        return index > max ? index : max;
                    } else {
                        return max;
                    }
                }, 0, initialValues) : 0;

                var getResult = function getResult(id, type, value) {
                    return {
                        id: id,
                        type: type,
                        value: (0, _value.encodeValue)(type, value)
                    };
                };

                return isTable ? (0, _unnest3.default)((isReverseTable ? (0, _reverse3.default)(v) : v).map(function (table, index) {
                    var values = (0, _toPairs3.default)(table);
                    var initialIndex = (0, _path3.default)([1, '#index'], (0, _find3.default)((0, _path3.default)([1, '#index']), values));

                    return values.map(function (_ref9) {
                        var _ref10 = _slicedToArray(_ref9, 2),
                            i = _ref10[0],
                            _ref10$ = _ref10[1],
                            type = _ref10$.type,
                            value = _ref10$.value;

                        return getResult(initialIndex ? '' + i + initialIndex : i + '#' + (initialLength + index + 1), type, value);
                    });
                })) : getResult(id, v.type, v.value);
            })), results);
        }
    }, {
        key: 'renderPage',
        value: function renderPage(viewMode) {
            var _props = this.props,
                data = _props.data,
                options = _props.options,
                language = _props.language;

            var page = (0, _pathOr3.default)({}, ['view', 'pages', this.state.page], data);

            return _react2.default.createElement(_Page2.default, {
                page: page,
                pageNumber: this.state.page,
                options: _extends({}, data.options, options),
                viewMode: viewMode,
                style: data.style,
                language: language,
                pagesCount: data.view.pages.length
            });
        }
    }, {
        key: 'renderPages',
        value: function renderPages(viewMode) {
            var values = this.state.values;
            var _props2 = this.props,
                data = _props2.data,
                options = _props2.options,
                language = _props2.language;

            var pages = (0, _pathOr3.default)([], ['view', 'pages'], data);
            var pagesLength = data.view.pages.length;

            return pages.map(function (page, index) {
                return _react2.default.createElement(_Page2.default, {
                    key: index,
                    page: page,
                    pageNumber: index,
                    options: _extends({}, data.options, options),
                    viewMode: viewMode,
                    style: data.style,
                    language: language,
                    pagesCount: pagesLength,
                    initialValues: values
                });
            });
        }
    }, {
        key: 'renderContent',
        value: function renderContent() {
            return _react2.default.createElement(
                _experiumPlayerHelpers.DictionariesContext.Provider,
                { value: this.getDictionaries() },
                _react2.default.createElement(_reactFinalForm.Form, {
                    subscription: { submitting: true, submitFailed: true, error: true },
                    mutators: formMutators,
                    onSubmit: this.onSubmit,
                    render: this.renderForm,
                    validate: this.validate,
                    initialValues: this.state.values
                })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var error = this.state.error;


            if (error) {
                return _react2.default.createElement(
                    _platform.Error,
                    null,
                    '\u041E\u0448\u0438\u0431\u043A\u0430 \u0432\u044B\u0432\u043E\u0434\u0430 \u0444\u043E\u0440\u043C\u044B'
                );
            }

            var pages = (0, _pathOr3.default)([], ['view', 'pages'], this.props.data);

            return pages.length ? this.renderContent() : null;
        }
    }]);

    return Player;
}(_react.Component);

Player.propTypes = {
    data: _propTypes2.default.object,
    onAbort: _propTypes2.default.func,
    onComplete: _propTypes2.default.func,
    onSave: _propTypes2.default.func,
    options: _propTypes2.default.object,
    language: _propTypes2.default.string,
    showProgress: _propTypes2.default.bool,
    onChange: _propTypes2.default.func
};
Player.defaultProps = {
    data: {},
    options: {}
};

var _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.goBack = function (values) {
        return _this3.setState(function (prev) {
            return { page: prev.page - 1, values: values };
        });
    };

    this.goForward = function (values) {
        return _this3.setState(function (prev) {
            return { page: prev.page + 1, values: values };
        });
    };

    this.onSubmit = function (values) {
        if (_this3.isLastPage()) {
            _this3.props.onComplete(_this3.getResult(values, false));
        } else {
            _this3.onSave(values, true);
            _this3.goForward(values);
        }
    };

    this.onSave = function (values, nextPage) {
        _this3.props.onAbort && _this3.props.onAbort(_this3.getResult(values, true, nextPage));
    };

    this.getProgress = function (nextPage) {
        var pagesLength = (0, _pathOr3.default)([], ['view', 'pages'], _this3.props.data).length;
        var page = nextPage ? _this3.state.page + 1 : _this3.state.page;
        var progress = Math.round(page * 100 / pagesLength);

        return progress;
    };

    this.renderForm = function (props) {
        var _props3 = _this3.props,
            data = _props3.data,
            onAbort = _props3.onAbort,
            options = _props3.options,
            language = _props3.language,
            showProgress = _props3.showProgress,
            _onChange = _props3.onChange;

        var dataOptions = data.options || {};

        var buttons = (0, _getButtons.getButtons)(dataOptions.buttons, language);

        var workloadCurrentLength = (0, _pathOr3.default)(0, ['options', 'workload_numsign'], data);
        var workloadLength = Number((0, _pathOr3.default)(0, ['options', 'workloadlength'], data) || 0);
        var workloadForm = !!(0, _pathOr3.default)(0, ['options', 'workload'], data);
        var workloadDocument = !!(0, _pathOr3.default)(0, ['options', 'use_in_workload'], data);

        var minLength = (0, _pathOr3.default)(0, ['options', 'minlength'], data);

        var pages = (0, _pathOr3.default)([], ['view', 'pages'], data);
        var pagesLength = pages.length;
        var pagesCount = dataOptions ? 1 : pagesLength;

        var viewMode = (0, _path3.default)(['answers', 'freeze'], data) || dataOptions.view_mode || options['view_mode'];

        return _react2.default.createElement(
            _platform.Wrapper,
            _extends({}, _this3.props, {
                pages: pages,
                language: language,
                workloadForm: workloadForm,
                workloadDocument: workloadDocument,
                workloadLength: workloadLength,
                workloadCurrentLength: workloadCurrentLength,
                viewMode: viewMode,
                minLength: minLength,
                getLength: _this3.getLength
            }),
            _this3.renderPages(viewMode),
            _onChange ? _react2.default.createElement(_reactFinalForm.FormSpy, {
                subscription: { values: true },
                onChange: function onChange(_ref11) {
                    var _values = _ref11.values;
                    return _onChange && _onChange(_this3.getResult(_values, true), _values);
                } }) : null,
            _react2.default.createElement(
                _reactFinalForm.FormSpy,
                {
                    subscriptions: { values: true, errors: true } },
                function (_ref12) {
                    var _values = _ref12.values,
                        errors = _ref12.errors;

                    var onSave = onAbort ? function () {
                        return _this3.onSave(_values);
                    } : null;

                    return _react2.default.createElement(_platform.Controls, {
                        onBack: function onBack() {
                            return _this3.goBack(_values);
                        },
                        onForward: function onForward() {
                            return _this3.goForward(_values);
                        },
                        handleSubmit: props.handleSubmit,
                        onSave: onSave,
                        disableBack: !_this3.state.page,
                        disableForward: _this3.isLastPage(),
                        viewMode: viewMode,
                        pagesCount: pagesCount,
                        formError: props.submitFailed ? errors.formError : null,
                        buttons: buttons,
                        showProgress: pagesCount > 1 && showProgress,
                        progress: _this3.getProgress()
                    });
                }
            )
        );
    };

    this.getLength = function (values) {
        var items = _this3.getResult(values, false).results.items;

        var length = items.filter(function (item) {
            return item ? (0, _contains3.default)(item.type, (0, _keys3.default)(_platform.formComponents.input)) || item.type === 'input' : false;
        }).reduce(function (result, item) {
            return item.value ? result + item.value.reduce(function (r, i) {
                return r + i.toString().length;
            }, 0) : result;
        }, 0);

        return length;
    };

    this.validate = function (values) {
        var minLength = (0, _pathOr3.default)(_this3.props.options.minlength, ['data', 'options', 'minlength'], _this3.props);

        if (_this3.isLastPage() && minLength) {
            var length = _this3.getLength(values) || 0;

            return length < minLength ? {
                formError: {
                    message: 'minLength',
                    length: length,
                    minLength: minLength
                }
            } : undefined;
        }

        return undefined;
    };
};

exports.default = Player;